import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useEducation } from "@/module/education/context/EducationContext";
import {
  missingApplicationPrefs,
  useRequiredApplicationPrefs,
} from "@/module/education/AddApplicaiton/requiredApplicationPrefs";

export default function AddApplicationAction() {
  const { handleSubmit, onSubmit, setError } = useEducation();
  // Red-starred Preferences (Country, Intake Year, Intake Month…) block create.
  const requiredPrefs = useRequiredApplicationPrefs();

  const submitIfComplete = (data: any) => {
    const missing = missingApplicationPrefs(
      requiredPrefs,
      data?.customInputScopes,
    );
    if (missing.length > 0) {
      for (const m of missing) {
        setError(`customInputScopes.${m.index}` as const, {
          type: "required",
          message: `${m.label} is required`,
        });
      }
      toast.error(
        `Please fill the required field${missing.length > 1 ? "s" : ""}: ${missing.map((m) => m.label).join(", ")}`,
      );
      return;
    }
    onSubmit(data);
  };

  return (
    <div className=" flex items-center justify-end">
      <div className="flex items-center gap-4">
        <Button variant="cancel">Cancel</Button>
        <Button variant="primary" onClick={handleSubmit(submitIfComplete)}>
          Create Application
        </Button>
      </div>
    </div>
  );
}
